export const languages = [
  "AR",
  "EN",
  "JP",
  "KR",
  "TW",
  "HK",
  "TH",
  "VN",
  "SG",
  "MY",
  "AU",
  "ID",
  "IN",
  "IN_RM",
  "VN_RM",
  "AE",
  "ME-EN",
  "ME-AR",
  "CZ",
  "DE",
  "DK",
  "EG",
  "ES",
  "FI",
  "FR",
  "CA-FR",
  "GB",
  "HU",
  "IL",
  "IT",
  "NL",
  "NO",
  "PL",
  "PT",
  "RO",
  "SA",
  "SA-EN",
  "SA-AR",
  "SE",
  "TR",
  "UA",
  "UA-UA",
  "ZA",
  "PH",
  "BD",
  "UK",
  "MX",
  "CO",
  "CN",
  "ACI",
  "B2B",
  "CIDOOW",
  "ESHOP",
  "MIR",
  "US",
  "ZAEC",
  "USES",
  "CA-EN",
  "BE-NL",
  "BE-FR",
  "LATIN",
  "BR",
  "KH",
  "LK",
  "NZ",
  "SK",
  "CH-FR",
  "CH-DE",
  "CH-EN",
]; // 當前擁有的語言包

export const languageMap = {
  TW: "zh-TW",
  HK: "zh-HK",
  CN: "zh-CN",
  EN: "en-US",
  US: "en-US",
  UK: "en-GB",
  CA: "en-CA",
  "CA-EN": "en-CA",
  "CA-FR": "fr-CA",
  JP: "ja-JP",
  KR: "ko-KR",
  FR: "fr-FR",
  DE: "de-DE",
  ES: "es-ES",
  IT: "it-IT",
  NL: "nl-NL",
  PT: "pt-PT",
  BR: "pt-BR",
  RU: "ru-RU",
  TR: "tr-TR",
  TH: "th-TH",
  VN: "vi-VN",
  ID: "id-ID",
  IN: "hi-IN",
  IN_RM: "en-IN",
  PH: "en-PH",
  MY: "ms-MY",
  SG: "en-SG",
  AU: "en-AU",
  NZ: "en-NZ",
  AE: "ar-AE",
  EG: "ar-EG",
  SA: "ar-SA",
  "SA-EN": "en-SA",
  "SA-AR": "ar-SA",
  "ME-AR": "ar-AE",
  "ME-EN": "en-AE",
  SE: "sv-SE",
  NO: "no-NO",
  FI: "fi-FI",
  DK: "da-DK",
  CZ: "cs-CZ",
  PL: "pl-PL",
  HU: "hu-HU",
  RO: "ro-RO",
  SK: "sk-SK",
  UA: "uk-UA",
  "UA-UA": "uk-UA",
  BE: "nl-BE",
  "BE-NL": "nl-BE",
  "BE-FR": "fr-BE",
  CH: "de-CH",
  "CH-DE": "de-CH",
  "CH-FR": "fr-CH",
  "CH-EN": "en-CH",
  ZA: "en-ZA",
  ZAEC: "en-ZA",
  CO: "es-CO",
  MX: "es-MX",
  AR: "es-AR",
  KH: "km-KH",
  LK: "si-LK",
  BD: "bn-BD",
};
